/** The mono counts line under the Sharing and Group page titles: the facts that size the page, nothing else. */

function count(value: number, singular: string, plural = `${singular}s`): string {
  return `${new Intl.NumberFormat("en-US").format(value)} ${value === 1 ? singular : plural}`;
}

export type SharingCounts = { loops: number; shared: number; rules: number };

export function sharingCountsLine({ loops, shared, rules }: SharingCounts): string {
  return [count(loops, "loop"), count(shared, "shared", "shared"), count(rules, "rule")].join(" · ");
}

export type GroupCounts = { members: number; teams: number; openInvitations: number | null };

export function groupCountsLine({ members, teams, openInvitations }: GroupCounts): string {
  const parts = [count(members, "member"), count(teams, "team")];
  if (openInvitations != null) parts.push(count(openInvitations, "open invitation"));
  return parts.join(" · ");
}
